import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "@/components/atoms/Accordions/Accordion/ClientAccordion";
import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { AccordionItemStoryblok } from "@/types/blok-types";
import { SbBlokData, storyblokEditable } from "@storyblok/js";
import styles from "./index.module.css";

interface Props {
  blok: AccordionItemStoryblok;
  index?: number;
  preview?: boolean;
}

export const AccordionItemBlok = ({ blok, index, preview }: Props) => {
  return (
    <AccordionItem
      className={styles.item}
      {...storyblokEditable(blok as unknown as SbBlokData)}
    >
      <AccordionTrigger>{blok.title}</AccordionTrigger>
      <AccordionContent>
        {blok.content?.map((blok) => (
          <StoryblokComponent preview={preview} blok={blok} key={blok._uid} />
        ))}
      </AccordionContent>
    </AccordionItem>
  );
};
